import { render, staticRenderFns } from "./CurriculumStudentViewNECYearly.vue?vue&type=template&id=6f9da458&scoped=true&"
import script from "./CurriculumStudentViewNECYearly.vue?vue&type=script&lang=ts&"
export * from "./CurriculumStudentViewNECYearly.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumStudentViewNECYearly.vue?vue&type=style&index=0&id=6f9da458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9da458",
  null
  
)

export default component.exports